const isAdmin = (): boolean => {
  const role = localStorage.getItem('userRole');
  return role === 'Admin';
};

export default isAdmin;
